"use strict";
import { Trans } from "uniswap/src/i18n";
export var BuyButtonStates = /* @__PURE__ */ ((BuyButtonStates2) => {
  BuyButtonStates2[BuyButtonStates2["WALLET_NOT_CONNECTED"] = 0] = "WALLET_NOT_CONNECTED";
  BuyButtonStates2[BuyButtonStates2["NOT_SUPPORTED_CHAIN"] = 1] = "NOT_SUPPORTED_CHAIN";
  BuyButtonStates2[BuyButtonStates2["INSUFFICIENT_BALANCE"] = 2] = "INSUFFICIENT_BALANCE";
  BuyButtonStates2[BuyButtonStates2["ERROR"] = 3] = "ERROR";
  BuyButtonStates2[BuyButtonStates2["IN_WALLET_CONFIRMATION"] = 4] = "IN_WALLET_CONFIRMATION";
  BuyButtonStates2[BuyButtonStates2["PROCESSING_TRANSACTION"] = 5] = "PROCESSING_TRANSACTION";
  BuyButtonStates2[BuyButtonStates2["FETCHING_TOKEN_ROUTE"] = 6] = "FETCHING_TOKEN_ROUTE";
  BuyButtonStates2[BuyButtonStates2["INVALID_TOKEN_ROUTE"] = 7] = "INVALID_TOKEN_ROUTE";
  BuyButtonStates2[BuyButtonStates2["NO_TOKEN_ROUTE_FOUND"] = 8] = "NO_TOKEN_ROUTE_FOUND";
  BuyButtonStates2[BuyButtonStates2["LOADING_ALLOWANCE"] = 9] = "LOADING_ALLOWANCE";
  BuyButtonStates2[BuyButtonStates2["IN_WALLET_ALLOWANCE_APPROVAL"] = 10] = "IN_WALLET_ALLOWANCE_APPROVAL";
  BuyButtonStates2[BuyButtonStates2["PROCESSING_APPROVAL"] = 11] = "PROCESSING_APPROVAL";
  BuyButtonStates2[BuyButtonStates2["REQUIRE_APPROVAL"] = 12] = "REQUIRE_APPROVAL";
  BuyButtonStates2[BuyButtonStates2["CONFIRM_UPDATED_PRICE"] = 13] = "CONFIRM_UPDATED_PRICE";
  BuyButtonStates2[BuyButtonStates2["PRICE_IMPACT_HIGH"] = 14] = "PRICE_IMPACT_HIGH";
  BuyButtonStates2[BuyButtonStates2["PAY"] = 15] = "PAY";
  return BuyButtonStates2;
})(BuyButtonStates || {});
export function getBuyButtonStateData(buyButtonState, theme, handleClickOverride, usingPayWithAnyToken, priceImpact) {
  const defaultBuyButtonState = {
    handleClick: () => void 0,
    buttonText: <Trans i18nKey="common.card.error.description" />,
    disabled: true,
    warningText: void 0,
    warningTextColor: theme.deprecated_accentWarning,
    helperText: void 0,
    helperTextColor: theme.neutral2,
    buttonColor: theme.accent1,
    buttonTextColor: theme.deprecated_accentTextLightPrimary
  };
  const buyButtonStateData = {
    [0 /* WALLET_NOT_CONNECTED */]: {
      ...defaultBuyButtonState,
      handleClick: handleClickOverride ?? (() => void 0),
      disabled: false,
      buttonText: <Trans i18nKey="common.connectWallet.button" />
    },
    [1 /* NOT_SUPPORTED_CHAIN */]: {
      ...defaultBuyButtonState,
      handleClick: handleClickOverride ?? (() => void 0),
      buttonText: <Trans i18nKey="common.switchNetworks" />,
      disabled: false,
      warningText: <Trans i18nKey="common.wrongNetwork" />
    },
    [2 /* INSUFFICIENT_BALANCE */]: {
      ...defaultBuyButtonState,
      buttonText: <Trans i18nKey="common.pay.button" />,
      warningText: <Trans i18nKey="common.insufficient.funds" />
    },
    [3 /* ERROR */]: {
      ...defaultBuyButtonState,
      warningText: <Trans i18nKey="common.error.wrong.tryAgain" />
    },
    [4 /* IN_WALLET_CONFIRMATION */]: {
      ...defaultBuyButtonState,
      buttonText: <Trans i18nKey="common.proceedInWallet.short" />
    },
    [5 /* PROCESSING_TRANSACTION */]: {
      ...defaultBuyButtonState,
      buttonText: <Trans i18nKey="common.transactionPending" />
    },
    [6 /* FETCHING_TOKEN_ROUTE */]: {
      ...defaultBuyButtonState,
      buttonText: <Trans i18nKey="common.fetchingRoute" />
    },
    [7 /* INVALID_TOKEN_ROUTE */]: {
      ...defaultBuyButtonState,
      buttonText: <Trans i18nKey="common.pay.button" />
    },
    [8 /* NO_TOKEN_ROUTE_FOUND */]: {
      ...defaultBuyButtonState,
      buttonText: <Trans i18nKey="common.insufficientLiquidity" />,
      buttonColor: theme.surface3,
      buttonTextColor: theme.neutral1,
      helperText: <Trans i18nKey="transaction.insufficientLiquidity" />
    },
    [9 /* LOADING_ALLOWANCE */]: {
      ...defaultBuyButtonState,
      buttonText: <Trans i18nKey="common.loadingAllowance" />
    },
    [10 /* IN_WALLET_ALLOWANCE_APPROVAL */]: {
      ...defaultBuyButtonState,
      buttonText: <Trans i18nKey="swap.approveInWallet" />
    },
    [11 /* PROCESSING_APPROVAL */]: {
      ...defaultBuyButtonState,
      buttonText: <Trans i18nKey="swap.approvalPending" />
    },
    [12 /* REQUIRE_APPROVAL */]: {
      ...defaultBuyButtonState,
      disabled: false,
      handleClick: handleClickOverride ?? (() => void 0),
      helperText: <Trans i18nKey="swap.approvalNeeded" />,
      buttonText: <Trans i18nKey="common.approve" />
    },
    [13 /* CONFIRM_UPDATED_PRICE */]: {
      ...defaultBuyButtonState,
      handleClick: handleClickOverride ?? (() => void 0),
      disabled: false,
      warningTextColor: theme.accent1,
      warningText: <Trans i18nKey="common.priceUpdated" />,
      buttonText: <Trans i18nKey="common.pay.button" />
    },
    [14 /* PRICE_IMPACT_HIGH */]: {
      ...defaultBuyButtonState,
      handleClick: handleClickOverride ?? (() => void 0),
      disabled: false,
      buttonColor: priceImpact ? priceImpact.priceImpactSeverity.color : defaultBuyButtonState.buttonColor,
      helperText: <Trans i18nKey="common.priceImpact" />,
      helperTextColor: priceImpact ? priceImpact.priceImpactSeverity.color : defaultBuyButtonState.helperTextColor,
      buttonText: <Trans i18nKey="swap.payAnyway" />
    },
    [15 /* PAY */]: {
      ...defaultBuyButtonState,
      handleClick: handleClickOverride ?? (() => void 0),
      disabled: false,
      buttonText: <Trans i18nKey="common.pay.button" />,
      helperText: usingPayWithAnyToken ? <Trans i18nKey="nft.refundsInEth" /> : void 0
    }
  };
  return buyButtonStateData[buyButtonState];
}
